<template>

  <vx-card :title="$t('class-room.class-room')" class="mb-4">

    <template slot="actions">
      <vs-checkbox class="inline-flex" v-model="form.classRoomInput.isActive">{{$t('class-room.is-active')}}
      </vs-checkbox>
    </template>
    <!------------------------------------- Student Limit Exceed ---------------------------------------------->
    <div class="vx-row" v-if="local.selectedClassRoomOwned && isStudentExceed">
      <div class="vx-col sm:w-2/2 w-full mb-3">
        <vs-alert active="true" color="danger" icon="icon-alert-triangle" icon-pack="feather">
          {{ $t('class-room.student-limit-exceed') }}
        </vs-alert>
      </div>
    </div>

    <!------------------------------------- Class Room Owned -------------------------------------------------->
    <div class="vx-row">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <ValidationProvider :name="$t('class-room.class-room-owned')" rules="required" v-slot="{ errors }">
          <label class="text-sm">{{$t('class-room.class-room-owned') + ' *'}}</label>
          <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'" :name="$t('class-room.class-room-owned')"
                    selectOnTab
                    @input="onSelectedClassRoomOwned"
                    :options="availableClassRoomsOwned"
                    class="w-full"
                    v-model="local.selectedClassRoomOwned"/>
          <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
        </ValidationProvider>
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <ValidationProvider :name="$t('class-room.name-local')" rules="required" v-slot="{ errors }">
          <vs-input :label="$t('class-room.name-local') + ' *'" class="w-full"
                    v-model="form.classRoomInput.nameLocal"/>
          <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
        </ValidationProvider>
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input :label="$t('class-room.name-eng')" class="w-full" v-model="form.classRoomInput.nameEng"/>
      </div>
    </div>

    <vs-divider/>

    <!---------------------------------------- Class Room Owned Desc ------------------------------------------>
    <div class="vx-row text-center">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <span>
          <p class="text-l font-semibold">
            <span :class="isStudentExceed ? 'text-danger':''">{{form.classRoomInput.studentRegisterQty}}</span>/{{ form.classRoomInput.capacity }}
          </p>
          <small class="text-grey">{{ $t('class-room.student-qty') }}</small>
        </span>
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <span>
          <p class="text-l font-semibold">
            {{ local.selectedClassRoomOwned ? moment(local.selectedClassRoomOwned.startDate).format(dateTimeFormat.momentYYYYMMDD):'-' }}
          </p>
          <small class="text-grey">{{ $t('class-room.start-date') }}</small>
        </span>
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <span>
          <p class="text-l font-semibold">
            {{ local.selectedClassRoomOwned ? moment(local.selectedClassRoomOwned.endDate).format(dateTimeFormat.momentYYYYMMDD):'-' }}
          </p>
          <small class="text-grey">{{ $t('class-room.end-date') }}</small>
        </span>
      </div>
    </div>

  </vx-card>

</template>

<script>
  import {state} from '../data';
  import ClassRoomOwned from '@/store/modules/class-room/classRoomOwned';
  import {createHelpers} from "vuex-map-fields";
  import {createNamespacedHelpers} from 'vuex';
  import vSelect from 'vue-select';
  import moment from 'moment';
  import {dateTimeFormat} from '@/utils/format'

  if (!state.store.ClassRoomOwned) state.registerModule(`ClassRoomOwned`, ClassRoomOwned);

  const {
    mapActions: mapClassRoomOwnedActions,
  } = createNamespacedHelpers(`ClassRoomOwned`);

  const {
    mapFields: mapClassRoomOwnedFields,
  } = createHelpers({
    getterType: `ClassRoomOwned/getField`,
    mutationType: `ClassRoomOwned/updateField`,
  });

  export default {
    components: {
      vSelect,
    },
    data() {
      return {
        local: state.local,
        store: state.store,
        form: state.local.form,
        dateTimeFormat: dateTimeFormat,
        moment: moment,
      }
    },
    computed: {
      ...mapClassRoomOwnedFields(['processing']),
      availableClassRoomsOwned() {
        return this.local.availableClassRoomsOwned;
      },
      isStudentExceed() {
        return this.local.form.classRoomInput.studentRegisterQty > this.local.form.classRoomInput.capacity;
      },
    },
    watch: {
      processing(data) {
        this.local.isProcessing = data;
      },
    },
    methods: {
      ...mapClassRoomOwnedActions({
        getAvailableClassRoomsOwned: 'getAvailableClassRoomsOwned',
      }),
      async onSelectedClassRoomOwned(val) {
        if (val) {
          //show description or class room owned
          this.form.classRoomInput.startDate = val.startDate;
          this.form.classRoomInput.endDate = val.endDate;
          this.form.classRoomInput.capacity = val.capacity;

          if (this.form.classSection.startClassDate) {
            if (moment(this.form.classSection.startClassDate).isBefore(val.startDate)) {
              this.form.classRoomInput.startDate = val.startDate;
            }
          }
        }
      },
      async initData() {
        //local variable
        this.local.availableClassRoomsOwned = await this.getAvailableClassRoomsOwned();
      },
    },
    async mounted() {
      //call local function init all data
      await this.initData();

    }
  }
</script>

<style scoped>

</style>
